export default __webpack_public_path__ + "static/media/DC_Try again_B2.478704d5.mp3";